import React, { memo } from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { labelName } from '../../UtilsWeb';
import * as Constant from '../../../constants/actionTypes';

const LoadingComponent = ({ isLoading, error }) => {
  if (isLoading) {
    return <LinearProgress color="secondary" style={{ position: 'absolute', top: 0 }} />;
  }
  if (error) {
    return <div style={{ marginLeft: 20 }}>{labelName(Constant.LABEL_SERVER_PAGE_NOT_FOUND)}</div>;
  }
  return null;
};

LoadingComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

LoadingComponent.defaultProps = {
  error: null,
};

export default memo(LoadingComponent);
